<template>
  <label
    ref="onetimeLabel"
    tabindex="0"
    :aria-label="translations.oneTime.title"
    class="pdp-purchase-option pdp-purchase-option-onetime"
    :class="{ 'is-checked': selectedProductType === PRODUCT_TYPE.ONETIME }"
  >
    <input
      name="purchase"
      type="radio"
      :value="PRODUCT_TYPE.ONETIME"
      :checked="selectedProductType === PRODUCT_TYPE.ONETIME"
      @change="setProductType(PRODUCT_TYPE.ONETIME)"
    />
    <div class="pdp-purchase-option-inner">
      <div class="pdp-purchase-option-main">
        <h5>{{ translations.oneTime.title }}</h5>
        <span>{{ translations.oneTime.subTitle }}</span>
      </div>
      <div class="pdp-purchase-option-price">
        <strong>
          {{ currentPriceFormatted }}
          <span v-if="currentCostPerItem">{{ currentCostPerItem }}</span>
        </strong>
        <span
          v-if="currentCompareAtPrice"
          class="pdp-purchase-option-price-compare"
        >
          {{ currentCompareAtPrice }}
        </span>
      </div>
    </div>
    <PurchaseOptionDropdown
      v-if="
        selectedProductType === PRODUCT_TYPE.ONETIME &&
          shouldShowFreeGiftDropdown
      "
      :title="freeGift.title"
      :subtitle="freeGift.subTitle"
      :options="freeGift.options"
      :value="selectedFreeGift.id"
      @change="onFreeGiftChange"
    />
    <PurchaseOptionDropdown
      v-if="
        selectedProductType === PRODUCT_TYPE.ONETIME &&
          upSell &&
          upSell.inventoryQuantity > 0
      "
      :title="upSell.dropdown.title"
      :subtitle="upSell.dropdown.subTitle"
      :options="upSell.options"
      :value="selectedUpsellProductQuantity"
      @change="setUpSellQuantity($event)"
    />
    <div
      v-if="
        selectedProductType === PRODUCT_TYPE.ONETIME &&
          variants &&
          variants.length > 1 &&
          variantSelectionEnabled
      "
      class="pdp-purchase-option-dropdown-select"
    >
      <select v-model="wrappedSelectedVariant">
        <option
          v-for="variant in variants"
          :key="variant.id"
          :value="variant.id"
        >
          {{ variant.title }}
        </option>
      </select>
      <svg class="icon icon-cheveron-down">
        <use xlink:href="#icon-cheveron-down" />
      </svg>
    </div>
  </label>
</template>

<script>
import * as ShopifyCurrency from '@shopify/theme-currency';
import $dom from 'cash-dom';

import { mapState, mapMutations } from 'vuex';
import { purchaseForm, mutations } from './store';
import { PRODUCT_TYPE } from './const';

import PurchaseOptionDropdown from './PurchaseOptionDropdown.vue';

import { costPerItemMixin } from './cost_per_item';

export default {
  name: 'OneTimePurchaseOption',

  components: {
    PurchaseOptionDropdown
  },

  mixins: [costPerItemMixin],

  computed: {
    ...mapState(purchaseForm, [
      'freeGift',
      'oneTime',
      'selectedFreeGift',
      'selectedProductType',
      'selectedSubscriptionFrequency',
      'selectedUpsellProductQuantity',
      'selectedVariant',
      'shouldShowFreeGiftDropdown',
      'translations',
      'upSell',
      'moneyFormat',
      'variants',
      'variantSelectionEnabled',
      'quantitySelector'
    ]),

    wrappedSelectedVariant: {
      get() {
        return this.selectedVariant.id;
      },
      set(newVal) {
        const value = parseInt(newVal);

        this.selectVariant(value);
      }
    },

    PRODUCT_TYPE: () => PRODUCT_TYPE,

    currentPrice() {
      return this.selectedVariant.price;
    },

    currentPriceFormatted() {
      return ShopifyCurrency.formatMoney(this.currentPrice, this.moneyFormat);
    },

    currentCompareAtPrice() {
      if (this.selectedVariant) {
        return this.selectedVariant.formattedCompareAtPrice;
      }

      return false;
    }
  },

  mounted() {
    $dom(document.body).on('keydown', e => {
      const { keyCode } = e;

      if (
        (keyCode === 32 || keyCode === 13) &&
        document.activeElement === this.$refs.onetimeLabel
      ) {
        e.preventDefault();

        this.setProductType(PRODUCT_TYPE.ONETIME);
      }
    });
  },

  methods: {
    ...mapMutations({
      selectVariant: `${purchaseForm}/${mutations.SELECT_VARIANT}`,
      setProductType: `${purchaseForm}/${mutations.SET_PRODUCT_TYPE}`,
      setUpSellQuantity: `${purchaseForm}/${mutations.SET_UPSELL_QUANTITY}`,
      setFreeGift: `${purchaseForm}/${mutations.SET_FREE_GIFT}`
    }),

    onFreeGiftChange(freeGiftId) {
      const newFreeGift = this.freeGift.collection.find(
        freeGift => freeGift.id === freeGiftId
      );

      this.setFreeGift(newFreeGift);
    }
  }
};
</script>
